import _ from 'lodash';
import axios from 'axios';
import setUrl from '../../../framework/App/SetUrl';
import { NETWORK } from '../../../framework/App/AppConstants';
import { PAGE_NAME } from '../../config/pageNames';
import { push } from 'connected-react-router';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { CONTINUE_API } from '../../config/apiEndpoints';

export const handleRedirect = (response, serverData) => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect, serverData);
        return true;
    }
    return false;
};

export const continueApplicationApi = () => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            url: CONTINUE_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data: {}
        })
        .then(async(response) => {
            if (handleRedirect(response, serverData)) {
                return;
            } else {
                dispatch(setServerData({
                    decisionModel: response.data,
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                dispatch(push(PAGE_NAME.DECISION_PAGE));
                dispatch(spinnerClose());
            }
        })
        .catch(error => {
            capeLog && capeLog('response:error, US_ContinuePageActions,' + (error && error.message));
            if (handleRedirect(error && error.response, serverData)) {
                return;
            } else if (_.get(error, 'response.data.err', false)) {
                dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
                dispatch(spinnerClose());
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for ContinuePage submit');
                setUrl(window, PAGE_NAME.ERROR_PAGE, serverData);
            }
        });
};
